<template>
    <div class="about">
      <div class="container banner">
        <img src="../../static/img/about/banner.png" alt="">
        <div class="content">
          <div class="nav-title">
            <h1 class="title-name">关于合美</h1>
            <hr>
          </div>
          <div class="article">
            <div class="part-f">
              <div class="part-l">
                <h3>合心呵护  美丽如初</h3>
                <p>合美月子中心坐落于国家5A级风景区淹城遗址公园内，是一所拥有星级居住环境、完善母婴专护配套设施、舒适私密空间的现代化月子中心，是一家把传统月子文化和现代医学研究技术相结合的入住式月子中心，以专业医护团队为母婴提供一站式的产后专业护理和系统健康管理服务月子中心。</p>
                <p>合美月子中心与北京和睦家合作，拥有国际化和专业化的医疗团队、独有的私家母婴服务，同时，专业护士也为产后母婴的健康提供了科学和专业的护理。</p>
                <p>合美秉承管家式服务理念，对产后母婴提供“多对一”的贴心服务——妇产科专家、盆底专科专家、新生儿专家、儿童保健专家、中医专家、高级营养师、医疗美容管家等多对一服务，为入合美月子中心的妈妈和宝宝保驾护航。</p>
              </div>
              <div class="part-r">
                <img src="../../static/img/about/illustration.png" alt="">
              </div>
            </div>
            <div class="part-f">
              <div class="part-l">
                <img src="../../static/img/about/illustration2.png" alt="">
              </div>
              <div class="part-r">
                <p>母婴保健营养团队由专业营养师及台湾著名月子餐药膳调理讲师陳和揚等组成，并针对孕产妇个体差异，为其量身定制个性营养月子餐及药膳调理，药膳汤全部选用台湾进口顶级药材和台湾进口特制水，让产妇在月子期间尽快的调整身体并增强体质。多项国际先进产后康复医疗、美容设备，帮助妈妈们快速重塑健康美丽!</p>
                <p>月子中心总占地面积三千多平米，一期投入使用近两千平米。一期开放13间套房的月子套房，其中包括两间高级VIP套房。超过10间各种产后康复和照顾宝宝用的功能房和周边的配套设施。月子中心所有硬装都选用水性科天无毒装修器材保证零甲醛。</p>
                <p>所有入住客户尊享独立套房，中心内设婴儿游泳馆、形体训练馆、专业美容、理疗养护馆、宝宝阳光房等场馆;配备骨盆矫正仪、综合治疗仪、普林格尔治疗仪、全身按摩仪、SPA仪、足浴、足疗等先进设备。为新妈妈提供产后康复及产后体形修复系列：产后子宫复旧、盆骨恢复、产后疲劳恢复、产后腹部恢复、淋巴排毒、产后中药汗蒸、产后瑜伽、产后塑形等项目。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "about"
    }
</script>

<style scoped lang="less">
.about{
  .banner{
    img{
      width: 100%;
      margin-bottom: 60px;
    }
    .article{
      .part-f{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .part-l{
          width: 520px;
        }
        .part-r{
          width: 660px;
        }
        h3{
          font-size: 30px;
          font-weight: normal;
          margin-bottom: 36px;
        }
        p{
          line-height: 28px;
          color: #666666;
          margin-bottom: 36px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue